import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'
import { Title } from '../../title/Title'

import styles from './FinalizeConfirmContent.module.scss'

interface IProps {
  finalizeVersion: (saveData: boolean) => void
  onlyConfirmation: boolean
}

export const FinalizeConfirmContent = ({ finalizeVersion, onlyConfirmation }: IProps) => {
  if (onlyConfirmation) {
    return (
      <div className={styles.root}>
        <Title align={'center'} text={getFormedEltTranslation('finalize-version')} />
        <Translation text={getFormedEltTranslation('are-you-sure')} />
        <div className={styles.btnWrapper}>
          <Button onClick={() => finalizeVersion(true)}>
            <Translation text={getFormedEltTranslation('finalize-btn')} />
          </Button>
        </div>
      </div>
    )
  }
  return (
    <div className={styles.root}>
      <Title align={'center'} text={getFormedEltTranslation('finalize-version')} />
      <Translation text={getFormedEltTranslation('do-need-save-data')} />
      <div className={styles.btnWrapper}>
        <Button onClick={() => finalizeVersion(true)}>
          <Translation text={getFormedEltTranslation('with-save-data')} />
        </Button>
        <Button className={styles.saveBtn} onClick={() => finalizeVersion(false)}>
          <Translation text={getFormedEltTranslation('without-save-data')} />
        </Button>
      </div>
    </div>
  )
}
